if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.isEnglish = document.documentElement.lang.toLowerCase().startsWith('en');
        this.shareText = this.isEnglish
          ? 'Just found this at #Empathikon. What do you think?'
          : 'Gerade bei #Empathikon gefunden. Wie findest du das?';
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
        this.isMobileDevice = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

        if (this.isMobileDevice && navigator.share) {
          this.useNativeShare();
        } else if (!this.isMobileDevice) {
          this.useEmailShare();
        } else {
          this.useClipboardFallback();
        }
      }

      useNativeShare() {
        this.elements.shareButton.dataset.shareMode = 'native';
        this.mainDetailsToggle.setAttribute('hidden', '');
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', async () => {
          try {
            await navigator.share({
              title: document.title,
              text: this.shareText,
              url: this.urlToShare,
            });
          } catch (error) {
            if (error.name !== 'AbortError') {
              this.useClipboardFallback();
              this.mainDetailsToggle.open = true;
            }
          }
        });
      }

      useEmailShare() {
        const subject = encodeURIComponent(this.isEnglish ? 'A find from Empathikon' : 'Fundstück bei Empathikon');
        const body = encodeURIComponent(`${this.shareText}\n\n${this.urlToShare}`);
        const mailtoUrl = `mailto:?subject=${subject}&body=${body}`;

        this.elements.shareButton.dataset.shareMode = 'email';
        this.elements.shareButton.dataset.shareTarget = mailtoUrl;
        this.elements.shareButton.setAttribute(
          'aria-label',
          this.isEnglish ? 'Share by email' : 'Per E-Mail teilen'
        );
        this.mainDetailsToggle.setAttribute('hidden', '');
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', () => {
          window.location.href = mailtoUrl;
        });
      }

      useClipboardFallback() {
        this.elements.shareButton.dataset.shareMode = 'clipboard';
        this.elements.shareButton.classList.add('hidden');
        this.mainDetailsToggle.removeAttribute('hidden');
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.mainDetailsToggle
          .querySelector('.share-button__copy')
          .addEventListener('click', this.copyToClipboard.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      async copyToClipboard() {
        try {
          await navigator.clipboard.writeText(`${this.shareText}\n${this.urlToShare}`);
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        } catch (_error) {
          this.elements.urlInput.focus();
          this.elements.urlInput.select();
        }
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
